import React, { useEffect, useState } from 'react';
import './consultas.css';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB5l5Bpnh7VeuEfw0li3DbJ9kjTPZPNjGg",
  authDomain: "ssdiyd-f96c9.firebaseapp.com",
  projectId: "ssdiyd-f96c9",
  storageBucket: "ssdiyd-f96c9.firebasestorage.app",
  messagingSenderId: "948041839084",
  appId: "1:948041839084:web:ea010158fca5b7671650c9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Cuidadoras = () => {

  const [folio, setFolio] = useState('');
  const [resultado, setResultado] = useState('');
  const [tipoResultado, setTipoResultado] = useState(''); // 'beneficiario' | 'reserva' | 'no' | 'no_encontrado' | 'error'
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verificarFolio = async () => {
    const folioLimpio = folio.trim().toUpperCase();

    if (folioLimpio.length !== 18) {
      setTipoResultado('error');
      setResultado('⚠️ La CURP debe tener exactamente 18 caracteres.');
      return;
    }

    setCargando(true);
    setResultado('');
    setTipoResultado('');

    try {
      const docRef = doc(db, 'cuidadoras', folioLimpio);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const datos = docSnap.data();
        const estatus = (datos.Estatus || '').toString().trim().toLowerCase();

        let mensaje = '';
        let tipo = '';

        switch (estatus) {
          case 'beneficiario':
            tipo = 'beneficiario';
            mensaje = `¡Felicidades, cuidadora o cuidador!

Has sido seleccionado (a) como beneficiario (a) del Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026.

El siguiente paso está por comenzar. Te invitamos a mantenerte pendiente de la página oficial de la Secretaría de Bienestar e Inclusión Social, así como de la información que se publique a través de sus medios oficiales.

También es importante que estés pendiente de tu línea telefónica, ya que podremos comunicarnos contigo para brindarte información sobre la continuidad del proceso.

Nos da mucho gusto que formes parte de este programa que reconoce y valora tu importante labor como persona cuidadora.`;
            break;

          case 'reserva':
            tipo = 'reserva';
            mensaje = `¡Gracias por participar!

Tu solicitud al Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026 se encuentra actualmente en reserva.

Esto significa que tu solicitud continúa considerada dentro del proceso y podrá avanzar de acuerdo con la disponibilidad y los criterios establecidos por el programa.

Te invitamos a mantenerte pendiente de la página oficial de la Secretaría de Bienestar e Inclusión Social, así como de tu línea telefónica, ya que podremos comunicarnos contigo para brindarte información sobre la continuidad del proceso.

Agradecemos tu participación y reconocemos la importante labor que realizas como persona cuidadora.`;
            break;

          case 'no':
            tipo = 'no';
            mensaje = `Agradecemos tu participación en el Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026.

En esta ocasión, tu solicitud no resultó beneficiada dentro del proceso de selección del programa.

Reconocemos y valoramos profundamente la importante labor que realizas como persona cuidadora.

Te invitamos a mantenerte pendiente de la página oficial de la Secretaría de Bienestar e Inclusión Social para conocer futuras convocatorias, programas y apoyos.`;
            break;

          default:
            tipo = 'error';
            mensaje = '⚠️ El estatus registrado no es válido. Contacta a soporte.';
            break;
        }

        setTipoResultado(tipo);
        setResultado(mensaje);

      } else {
        // CURP NO EXISTE EN LA COLECCIÓN
        setTipoResultado('no_encontrado');
        setResultado(`La CURP ingresada no se encuentra registrada en nuestro sistema.

Te sugerimos verificar que hayas escrito correctamente los 18 caracteres de tu CURP.`);
      }

    } catch (error) {
      console.error('Error:', error);
      setTipoResultado('error');
      setResultado('⚠️ Ocurrió un error al consultar. Intenta de nuevo más tarde.');
    } finally {
      setCargando(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') verificarFolio();
  };

  // Determinar el color de fondo del recuadro según el tipo de resultado
  const getBgColor = () => {
    switch (tipoResultado) {
      case 'beneficiario':
        return 'rgba(65, 12, 26, 0.48)';
      case 'reserva':
        return 'rgba(255, 165, 0, 0.7)';
      case 'no':
        return 'rgba(139, 0, 0, 0.7)';
      case 'no_encontrado':
        return 'rgba(70, 70, 70, 0.7)';
      default:
        return 'rgba(255, 165, 0, 0.7)';
    }
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/Tzuhu_BG.png')`,
        backgroundSize: '95%',
        backgroundPosition: 'top center',
        backgroundRepeat: 'repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h4
            className='title'
            style={{
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026
            <br />
          </h4>

          <p
            style={{
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              marginTop: '-10px',
              textShadow: '2px 2px 6px rgba(0,0,0,0.7)'
            }}
          >
            Consulta tu resultado<br />
          </p>

          <div style={{ textAlign: 'center', margin: '20px' }}>
            <input
              type="text"
              placeholder="Ingresa tu CURP"
              value={folio}
              onChange={(e) => setFolio(e.target.value)}
              onKeyPress={handleKeyPress}
              maxLength={18}
              disabled={cargando}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                marginRight: '10px',
                textTransform: 'uppercase'
              }}
            />

            <button
              onClick={verificarFolio}
              disabled={cargando}
              style={{
                padding: '10px 20px',
                backgroundColor: cargando ? '#666' : '#8B0000',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: cargando ? 'not-allowed' : 'pointer'
              }}
            >
              {cargando ? 'Consultando...' : 'Consultar'}
            </button>

            {resultado && (
              <div style={{
                marginTop: '20px',
                color: 'white',
                textShadow: '2px 2px 6px rgba(0,0,0,0.7)',
                padding: '20px',
                backgroundColor: getBgColor(),
                borderRadius: '10px',
                maxWidth: '800px',
                margin: '20px auto',
                lineHeight: '1.6',
                fontSize: '16px',
                whiteSpace: 'pre-line',
                textAlign: 'left'
              }}>
                {resultado}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Cuidadoras;